import { Injectable } from '@angular/core'
import { Select, State, Action, StateContext, Selector, NgxsOnInit, Store, NgxsSimpleChange } from '@ngxs/store'
import { Observable } from 'rxjs';
import { UserState } from 'src/app/state-man/state/user.state';
import { User } from 'src/app/state-man/models/user.model';
import { StorageService } from 'src/app/services/storage.service';
import { UserDetail } from '../models/user-detail.model';
import { UserDetailService } from '../../services/user-detail.service';
import { UserDetailActions } from '../actions/user-detail.actions';
import { stateContentChanged } from './state-content-changed'

export class UserDetailStateModel {
    is_refreshing: boolean
    userDetail: UserDetail
    static getDefault(): UserDetail {
        return {
            manager: '',
            manager_phone: '',
            jsa_emergency_contact_phone: '',
            sick_hours_given_ytd: 0,
            sick_hours_used_ytd: 0,            
            vacation_hours_offer: 0,
            vacation_hours_carry_over: 0,
            vacation_hours_given_ytd: 0,
            vacation_hours_used_ytd: 0            
        }
    }
}

@State<UserDetailStateModel>({
    name: 'user_detail',
    defaults: {
        is_refreshing: true,
        userDetail: UserDetailStateModel.getDefault()
    }
})
@Injectable()
export class UserDetailState implements NgxsOnInit {
    @Select(UserState.getUser) user$: Observable<User>
    user: User

    constructor(        
        private userDetailService: UserDetailService,
        private store: Store,
        private storageService: StorageService
    ) {}

    async ngxsOnInit(ctx: StateContext<UserDetailStateModel>) {                
        this.user$.subscribe(async (user: User) => {        
            this.user = user    
            if (user.is_logged_in) {     
                this.storageService.events.subscribe(async (status: any) => {
                    if (this.storageService.is_initialized) {
                        await this.reloadStateFromStorage()                        
                    }
                })                           
            }
        }) 
    }

    async ngxsOnChanges(change: NgxsSimpleChange) {       
        if (this.storageService.is_initialized && stateContentChanged(change)) {
            const state_model: UserDetailStateModel = change.currentValue
            this.storageService.set('user_detail', JSON.stringify(state_model))    
        }      
    }

    async reloadStateFromStorage() {        
        const json = await this.storageService.get('user_detail');        
        if (json) {
            const state_model: UserDetailStateModel = JSON.parse(json)
            if (state_model) {
                this.store.dispatch(new UserDetailActions.Init(state_model));
                return
            }
        }
        this.store.dispatch(new UserDetailActions.Refresh())
    }

    async reloadStateFromApi() : Promise<boolean> {    
        const obj = await this.userDetailService.getByUserId(this.user.id)            
        if (obj != null) {
          const one = UserDetail.buildOne(obj)                  
          this.store.dispatch(new UserDetailActions.Set(one))
          return true
        }
        return false
    }
  
    @Selector()
    static getState(state: UserDetailStateModel) {
        return state
    }

    @Selector()
    static get(state: UserDetailStateModel) {
        return state.userDetail
    }

    @Selector()
    static getIsRefreshing(state: UserDetailStateModel) {
        return state.is_refreshing
    }

    @Action(UserDetailActions.Refresh)
    async refresh({patchState}: StateContext<UserDetailStateModel>, {  }:UserDetailActions.Refresh) {
        patchState({is_refreshing: true})
        if (!await this.reloadStateFromApi()) {            
            patchState({is_refreshing: false})
        }
    }

    @Action(UserDetailActions.Init)
    init({setState, getState}: StateContext<UserDetailStateModel>, { payload }:UserDetailActions.Init) {                  
        const state = getState()
        payload.is_refreshing = state.is_refreshing
        setState(payload)
        this.store.dispatch(new UserDetailActions.Refresh())
    }
    
    @Action(UserDetailActions.Set)
    set({setState, getState}: StateContext<UserDetailStateModel>, { payload }:UserDetailActions.Set) {             
        const state = getState()  
        setState({   
            is_refreshing: false,          
            userDetail: payload
        })
    }
}
